@if (loadingService.loading$ | async) {
  <mat-progress-spinner
    id="site-loading-bar"
    diameter="48"
    mode="indeterminate"
  ></mat-progress-spinner>
}
